import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import MatchDetailPage from "@/pages/detail/page";
import TeamDetailPage from "@/pages/team/page";
import TeamsPage from "@/pages/teams/page";
import PlayerDetailPage from "@/pages/player/page";
import PlayersPage from "@/pages/players/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:id", element: <CategoryPage /> },
      { path: "detail/:matchId", element: <MatchDetailPage /> },
      { path: "team/:teamId", element: <TeamDetailPage /> },
      { path: "teams", element: <TeamsPage /> },
      { path: "player/:playerId", element: <PlayerDetailPage /> },
      { path: "players", element: <PlayersPage /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/detail/:newsId", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;